import { render, staticRenderFns } from "./UserActivityHistoryReport.vue?vue&type=template&id=c2d6e7f2&scoped=true"
import script from "./UserActivityHistoryReport.vue?vue&type=script&lang=js"
export * from "./UserActivityHistoryReport.vue?vue&type=script&lang=js"
import style0 from "./UserActivityHistoryReport.vue?vue&type=style&index=0&id=c2d6e7f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d6e7f2",
  null
  
)

export default component.exports